"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantSearchFormToJSON = exports.ApplicantSearchFormFromJSONTyped = exports.ApplicantSearchFormFromJSON = void 0;
function ApplicantSearchFormFromJSON(json) {
    return ApplicantSearchFormFromJSONTyped(json, false);
}
exports.ApplicantSearchFormFromJSON = ApplicantSearchFormFromJSON;
function ApplicantSearchFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'term': json['term'],
    };
}
exports.ApplicantSearchFormFromJSONTyped = ApplicantSearchFormFromJSONTyped;
function ApplicantSearchFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'term': value.term,
    };
}
exports.ApplicantSearchFormToJSON = ApplicantSearchFormToJSON;
//# sourceMappingURL=ApplicantSearchForm.js.map